<script setup lang="ts">
import type { WishlistPayload } from '@yescapa-dev/ysc-api-js/legacy'
import { WISHLIST_ADD_EVENT } from '~/utils/analytics/wishlists'
import type { SubmitAction } from '~/types/commons'
import { YSC_API_WISHLIST_ERROR } from '~/utils/error/YscErrorClasses'

interface Props {
  idCamper: number
}

const props = defineProps<Props>()
defineEmits<{
  close: []
}>()

enum MODALS {
  CREATE_WISHLIST = 'create-wishlist',
}

const { lastModal, openModal, closeTopModal } = useStackedModals()

const { withErrorManagerHandling } = useWithErrorManagerHandling()
const wishlistsStore = useWishlistsStore()

await useAsyncData(`fetch-camper-${props.idCamper}-wishlist`, async () => {
  await withErrorManagerHandling(
    () => wishlistsStore.fetchWishlists({ refresh: false }),
    YSC_API_WISHLIST_ERROR,
    false,
  )
  return true
})

const { event } = useGtag()
onMounted(() => {
  event(WISHLIST_ADD_EVENT)
})

const onSubmitEdition: SubmitAction<WishlistPayload> = async ({ form } = {}) => {
  if (!isDefined(form)) {
    return
  }

  try {
    await withErrorManagerHandling(
      () => wishlistsStore.updateOrCreateWishlist({ form: toValue(form), create: true }),
      YSC_API_WISHLIST_ERROR,
      true,
    )
  }

  catch (_e) {
    return
  }
  closeTopModal()
}
</script>

<template>
  <div>
    <YscModal
      @close="$emit('close')"
    >
      <template #title>
        {{ $t('commons.my_wishlists') }}
      </template>

      <ul class="flex flex-col">
        <AppModalCamperWishlistItem
          v-for="wishlist of wishlistsStore.all"
          :key="wishlist.id"
          :id-camper="idCamper"
          :wishlist="wishlist"
        />
      </ul>

      <template #footer>
        <div class="flex justify-end">
          <button
            class="my-2 btn btn-secondary"
            @click="openModal(MODALS.CREATE_WISHLIST)"
          >
            {{ $t('commons.actions.create_wishlist') }}
          </button>
        </div>
      </template>
    </YscModal>

    <LazyAppModalWishlistEdition
      v-if="lastModal === MODALS.CREATE_WISHLIST"
      :submit-action="onSubmitEdition"
      @close="closeTopModal()"
    />
  </div>
</template>
